import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { HeroSection } from './components/HeroSection';
import { ProofBar } from './components/ProofBar';
import { PainSection } from './components/PainSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductSection } from './components/ProductSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ForWhomSection } from './components/ForWhomSection';
import { OfferSection } from './components/OfferSection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="min-h-screen w-full flex flex-col" data-id="element-0" data-mp="28u5y0mx2p5cu">
      <UrgencyBar data-id="element-1" data-mp="28surifc8tji1" />
      <HeroSection data-id="element-2" data-mp="28sbe9bxjfjac" />
      <ProofBar data-id="element-3" data-mp="23vkw8j26adma" />
      <PainSection data-id="element-4" data-mp="23w4fq47h1a2f" />
      <MechanismSection data-id="element-5" data-mp="23ujk0b9f7l2z" />
      <ProductSection data-id="element-6" data-mp="23v2u55stx56g" />
      <BenefitsSection data-id="element-7" data-mp="3ijxnsm94vshs" />
      <ForWhomSection data-id="element-8" data-mp="3ikr002qv3a7b" />
      <OfferSection data-id="element-9" data-mp="3ij668fcdfvai" />
      <FaqSection data-id="element-10" data-mp="3ijpet5g4t7bv" />
      <FinalCta data-id="element-11" data-mp="3ii4ppvcl6gle" />
      <Footer data-id="element-12" data-mp="3mlat8v8bdto6" />
      <RecentPurchaseToast data-id="element-13" data-mp="3mkrc3gqhn9b7" />
    </div>;
}